import { render, staticRenderFns } from "./component-special.vue?vue&type=template&id=6e3a6ec4&"
import script from "./component-special.vue?vue&type=script&lang=js&"
export * from "./component-special.vue?vue&type=script&lang=js&"
import style0 from "./component-special.vue?vue&type=style&index=0&id=6e3a6ec4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports